import { useLanguage } from 'store/locale/hooks/useLanguage'
import { metaData } from '../../data/metadata/metaData'
import { useEffect, useState } from 'react'

export const useHelmet = (url: String) => {
  const { language } = useLanguage()
  const [meta, setMeta] = useState(metaData(language).default)

  useEffect(() => {
    const lowerCasedValue = url.toLowerCase().trim()

    for (const [key, value] of Object.entries(metaData(language))) {
      if (lowerCasedValue.indexOf(key) !== -1) {
        setMeta(value)
      }
    }
  }, [language, url])

  return meta
}
